"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchableSelectAsync = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactSelect = require("react-select");
var _async = _interopRequireDefault(require("react-select/async"));
var _SearchableSelect = require("b2b-components/theme/components/Form/SearchableSelect");
var _Control = require("b2b-components/theme/components/Form/SearchableSelect/Control");
var _DropdownIndicator = require("b2b-components/theme/components/Form/SearchableSelect/DropdownIndicator");
var _LoadingIndicator = require("b2b-components/theme/components/Form/SearchableSelect/LoadingIndicator");
var _Option = require("b2b-components/theme/components/Form/SearchableSelect/Option");
var _upperCase = require("b2b-components/utils/upperCase");
var _classnames = _interopRequireDefault(require("classnames"));
require("../SearchableSelect/SearchableSelect.scss");
const SearchableSelectAsync = _ref => {
  let {
    onChange,
    onOptionsLoad,
    defaultOptions,
    defaultValue,
    cacheOptions = true,
    isDisabled = false,
    hasError = false,
    styleType = _SearchableSelect.STYLE_TYPE.outlined,
    placeholder = '',
    loadingText,
    noOptionsText,
    className
  } = _ref;
  const rootClassName = (0, _classnames.default)('cds-Form-Input', `cds-Form-Input--${(0, _upperCase.upperCaseFirst)(styleType)}`, {
    'cds-Form-Input--Error': hasError
  }, className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: rootClassName
  }, /*#__PURE__*/_react.default.createElement(_async.default, {
    onChange: onChange,
    isDisabled: isDisabled,
    defaultOptions: defaultOptions,
    defaultValue: defaultValue,
    loadOptions: onOptionsLoad,
    cacheOptions: cacheOptions,
    loadingMessage: () => loadingText,
    placeholder: placeholder,
    isSearchable: true,
    components: {
      Control: _Control.Control,
      DropdownIndicator: _DropdownIndicator.DropdownIndicator,
      Option: _Option.Option,
      LoadingIndicator: _LoadingIndicator.LoadingIndicator,
      NoOptionsMessage: props => /*#__PURE__*/_react.default.createElement(_reactSelect.components.NoOptionsMessage, props, noOptionsText),
      IndicatorSeparator: null
    },
    className: "cds-SearchableSelect",
    classNamePrefix: "cds-SearchableSelect"
  }));
};
exports.SearchableSelectAsync = SearchableSelectAsync;
//# sourceMappingURL=SearchableSelectAsync.js.map